import React from 'react'
import {Table, ButtonToolbar, ButtonGroup} from 'reactstrap';
import {Link} from 'react-static'
import ItemMenu from './ItemMenu'

export default({products, deleteProduct}) => <div className=" card-box table-responsive">
  <ButtonToolbar className="justify-content-between">
    <ButtonGroup/>
    <ButtonGroup>
      <Link to='/products/new' className="btn btn-success btn-sm btn-primary">Neues Produkt</Link>
    </ButtonGroup>
  </ButtonToolbar>

  <Table striped className="m-t-20">
    <thead>
      <tr>
        <th align="left">Produktnummer</th>
        <th align="left">Name</th>
        <th align="left">Beschreibung</th>
        <th align="left">Preis</th>
        <th align="left">Erstellt am</th>
        <th align="left"/>
      </tr>
    </thead>
    <tbody>
      {
        !!products && products.map(product => <tr key={product.id}>
          <td>
            <Link to={`/products/${product.id}/show`}>{product.number}</Link>
          </td>
          <td>{product.name}</td>
          <td>{product.description}</td>
          <td>{product.price}</td>
          <td>{product.createdAt}</td>
          <td>
            <ItemMenu>
              <Link className="dropdown-item" to={`/products/${product.id}/show`}>Bearbeiten</Link>
              <a className="dropdown-item" href="#" onClick={(e) => {
                  e.preventDefault();
                  deleteProduct(product.id)
                }}>
                Löschen
              </a>
            </ItemMenu>
          </td>
        </tr>)
      }
    </tbody>
  </Table>

</div>



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/components/ProductList.js